export default __webpack_public_path__ + "static/media/logo.a2d3ec81.png";